<template>
  <div class="projectVideoContainer">
    <video
      :src="require('@/assets/projectImages/' + videoSource + '.mp4')"
      type="video/mp4"
      x="50%"
      y="50%"
      autoplay
      loop
      muted
    />
    <h4>{{ caption }}</h4>
  </div>
</template>

<script>
export default {
  name: "WorksImageContainer",
  props: {
    caption: String,
    videoSource: String
  },
  methods: {
    videoSrc: function(Str) {
      return require("@/assets/projectImages/" + Str);
    }
  }
};
</script>
<style lang="scss" scoped>
.projectVideoContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  video {
    max-width: 100%;
    display: block;
    object-fit: contain;
    overflow: hidden;
  }
  h4 {
    color: $mid-grey;
    text-align: center;
    font-size: 1.2rem;
    flex: 1;
    padding: 1.5rem 0rem;
  }
}
</style>
